import React, { FunctionComponent, useEffect, useState } from 'react';
import { AppState, Platform } from 'react-native';
import { TranslateProp } from '../../common-types';
import Healthkit from '../../ConnectedApps/HealthKit/healthkit';
import { Logger } from '../../utils';
import ConnectedItem from './ConnectedItem';
import { showMessage } from '../../ui/components/Toast';

interface IProps {
  t: TranslateProp
  isEnabled: boolean
}

const AppleWatchConnectedDevice: FunctionComponent<IProps> = ({ t, isEnabled = false }) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [isSetup, setIsSetup] = useState(false);

  useEffect(() => {
    if (Platform.OS === 'ios') {
      Healthkit.isAppInstalledOnConnectedDevice()
        .then((deviceSetup) => setIsSetup(deviceSetup))
        .catch((err) => Logger.notify(err));
    }
  });

  const requestHealthAuth = async () => {
    const { success, errorDisplayMessage } = await Healthkit.requestAuthorization();
    if (!success) {
      showMessage(errorDisplayMessage);
    }
  };

  useEffect(() => {
    Healthkit.isConnectedDeviceAvailable()
      .then((isAvailable) => setShouldShow(isAvailable))
      .catch((err) => Logger.notify(err));
  }, [isSetup]);

  if (!shouldShow) {
    return <></>;
  }

  const buttonTitle = () => {
    if (Platform.OS === 'ios') {
      const majorVersionIOS = parseInt(Platform.Version, 10);
      if (majorVersionIOS < 17) {
        return t('notSupported');
      }
    }
    if (isSetup && !isEnabled) {
      return t('connectHealth');
    }
    if (isSetup && isEnabled) {
      return t('installed');
    }
    return t('install');
  };
  const handleAppleWatchConnect = async () => {
    if (isSetup && !isEnabled) {
      await requestHealthAuth();
    }
    if (!isSetup) {
      showMessage(t('installCompanionApp'));
    }
  };

  return (
    <ConnectedItem
      t={t}
      onPress={handleAppleWatchConnect}
      title={t('appleWatch')}
      buttonTitle={buttonTitle()}
    />
  );
};

export default AppleWatchConnectedDevice;
